export default "/_next/static/images/how-it-works-2x-37f4f32899ec941edaef166d9b817ab5.png";